import createMuiTheme, { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import { cssVars, customBoxShadow, rootFontSize } from "./globalCssVars";
import { CustomPalette } from "./common/types/appSettings";

export const appBarHeight = {
  gtSm: cssVars.webToolbarHeight,
  sm: 50 / rootFontSize
};

export const mobileStepperHeight = 80 / rootFontSize;

export function getCustomTheme(customPalette: CustomPalette): ThemeOptions {
  const defaultTheme = createMuiTheme();
  const listMargin = 1;
  const listBorderRadius = 5 / rootFontSize;

  const listStyles = {
    borderRadius: listBorderRadius + "rem",
    boxShadow: customBoxShadow,
    marginTop: listMargin + "rem",
    "&:first-child": {
      marginTop: 0
    },
    "&:last-child": {
      marginBottom: 0
    },
    backgroundColor: "white"
  };

  const expansionPanelStyles = {
    ...listStyles,
    "&:first-child": {
      borderTopRightRadius: listBorderRadius + "rem",
      borderTopLeftRadius: listBorderRadius + "rem",
      marginTop: 0
    },
    "&:last-child": {
      borderBottomLeftRadius: listBorderRadius + "rem",
      borderBottomRightRadius: listBorderRadius + "rem",
      marginBottom: 0
    },
    marginRight: listMargin + "rem",
    marginLeft: listMargin + "rem"
  };

  return {
    typography: {
      useNextVariants: true,
      fontFamily: "'Roboto', sans-serif"
    },
    spacing: {
      unit: 0.5
    },
    palette: {
      primary: {
        main: customPalette.primary.main,
        contrastText: customPalette.primary.contrastText
      },
      secondary: {
        main: customPalette.secondary.main,
        contrastText: customPalette.secondary.contrastText
      }
    },
    mixins: {
      toolbar: {
        minHeight: appBarHeight.sm + "rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        [defaultTheme.breakpoints.up("md")]: {
          minHeight: appBarHeight.gtSm + "rem",
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem"
        }
      }
    },
    overrides: {
      MuiExpansionPanel: {
        root: {
          "&:before": {
            height: 0
          },
          ...expansionPanelStyles
        },
        expanded: {
          ...expansionPanelStyles
        }
      },
      MuiExpansionPanelSummary: {
        content: {
          alignItems: "center"
        }
      },
      MuiList: {
        root: {},
        padding: {
          paddingTop: "1rem",
          paddingBottom: "1rem",
          padding: listMargin + "rem"
        }
      },
      MuiListItem: {
        root: {
          ...listStyles
        }
      },
      MuiListItemText: {
        primary: {
          color: customPalette.secondary.main,
          fontWeight: 500,
          fontSize: "1.25rem",
          lineHeight: "1.2"
        },
        secondary: {
          fontWeight: 500,
          color: "rgba(0,0,0, 0.87)",
          marginTop: "0.25rem"
        }
      },
      // TODO: AAH There is probably a better way to override this, but
      // I don't know what it is.
      MuiStepLabel: {
        alternativeLabel: {
          marginTop: `${2 / rootFontSize}rem !important`
        }
      },
      MuiToolbar: {
        gutters: {}
      },
      MuiButton: {
        outlinedPrimary: {
          background: "#fff"
        }
      }
    }
  };
}
